import { render, staticRenderFns } from "./b-popup-customer-follow-up-detail.vue?vue&type=template&id=251f691e&scoped=true"
import script from "./b-popup-customer-follow-up-detail.vue?vue&type=script&lang=js"
export * from "./b-popup-customer-follow-up-detail.vue?vue&type=script&lang=js"
import style0 from "./b-popup-customer-follow-up-detail.vue?vue&type=style&index=0&id=251f691e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f691e",
  null
  
)

export default component.exports